import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import ProductList from '@/views/ProductList.vue'
import ProductDetail from '@/views/ProductDetail.vue'
import Cart from '@/views/Cart.vue'
import Auth from '@/views/Auth.vue'
import ShippingPolicy from '@/views/ShippingPolicy.vue'
import ReturnPolicy from '@/views/ReturnPolicy.vue'
import AccessibilityStatement from '@/views/AccessibilityStatement.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function(location){ return originalPush.call(this, location).catch(e => e) }

const routes = [
  { path:'/', name:'home', component: Home },
  { path:'/home', redirect:'/' },
  { path:'/items', name:'products', component: ProductList },
  { path:'/items/p/:id', name:'product-detail', component: ProductDetail },
  { path:'/bag', name:'cart', component: Cart },
  { path:'/login', name:'login', component: Auth },
  { path:'/shipping-policy', name:'shipping-policy', component: ShippingPolicy },
  { path:'/return-policy', name:'return-policy', component: ReturnPolicy },
  { path:'/accessibility-statement', name:'accessibility-statement', component: AccessibilityStatement },
  { path:'*', redirect:'/' },
]
export default new VueRouter({ 
  mode:'history', 
  base:process.env.BASE_URL, 
  routes, 
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
